import React from "react";
import Icon, { IconName } from "./icons";


interface tooltipProps {
    isMobile: boolean;
    showPopUp: boolean;
    title: string;
    desc: string;
    onClose: Function;
}

export default function PopUpNotification(props: tooltipProps) {
    const { isMobile, showPopUp, title, desc, onClose } = props;
   return (
    <>
      {showPopUp && (
        <div className={`absolute bg-white drop-shadow-lg p-3 ${isMobile ? "w-full top-28 rounded-xl" : "w-[23rem] right-8 left-auto top-48 rounded"} z-50 text-sm font-normal`}>
          <div className=" flex justify-between">
            <div className="p-2 pr-5"><Icon name="notificationInfo" className="h-9 w-9 text-secondary-400" /></div>
            <div className="flex justify-start flex-col">
              <div className="flex justify-between pt-3">
                <h1 className="text-lg text-secondary-500 font-medium">{title}</h1>
                <div data-testid='popup-close' className="-mt-2 cursor-pointer" onClick={() => onClose()}><Icon name="close" className="h-6 w-6 text-secondary-300" /></div>
              </div>
              <p className="p-2 text-sm text-secondary-500 pl-0">{desc}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
